import React from 'react'
import RejectedData from '../DataComponent/RejectedData.jsx'
import Header from '../../../component/Header.jsx'
import { Box, useMediaQuery } from '@mui/material'
import { FormattedMessage } from 'react-intl'

export const RejectedIndex = ({ boxSize, defaultBox }) => {

    const isLargeScreen = useMediaQuery("(min-width: 1200px)")

    return (
        <Box sx={boxSize}>
            <Header title={<FormattedMessage id='rejectedNav' />} />

            <Box
                mt="20px"
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap="20px"
                sx={{
                    "& > div": { gridColumn: isLargeScreen ? undefined : "span 12" }
                }}
            >
                <Box sx={defaultBox}>
                    <RejectedData />
                </Box>
            </Box>
        </Box>
    )
}
